import { useTranslation } from "../../../i18n/useTranslation";

export const tasks = [
  "harvesting",
  "seeding",
  "tilling",
  "spraying",
  "spreading",
  "mowing",
  "pressing",
  "other",
] as const;
export type Task = (typeof tasks)[number];
export const translateTask: (
  t: ReturnType<typeof useTranslation>["t"],
  task: Task
) => string = (t, task) => {
  return t(`data.task.${task}`);
};

export const tillingDepths = ["shallow", "medium", "deep"] as const;
export type TillingDepth = (typeof tillingDepths)[number];
export const translateTillingDepth: (
  t: ReturnType<typeof useTranslation>["t"],
  tillingDepth: TillingDepth
) => string = (t, tillingDepth) => {
  return t(`data.tillingDepth.${tillingDepth}`);
};

export const dropSizes = ["fine", "medium", "coarse"] as const;
export type DropSize = (typeof dropSizes)[number];
export const translateDropSize: (
  t: ReturnType<typeof useTranslation>["t"],
  dropSize: DropSize
) => string = (t, dropSize) => {
  return t(`data.dropSize.${dropSize}`);
};

export const crops = [
  "barley",
  "wheat",
  "maize",
  "rye",
  "oat",
  "sorghum",
  "triticale",
  "rapeseed",
  "grass_and_clover",
  "sunflower",
  "potato",
  "beetroot",
  "carrot",
  "broad_bean",
  "pea",
  "common_bean",
  "soybean",
  "cotton",
  "rice",
  "sugarcane",
] as const;
export type Crop = (typeof crops)[number];
export const translateCrop: (
  t: ReturnType<typeof useTranslation>["t"],
  crop: Crop
) => string = (t, crop) => {
  return t(`data.crop.${crop}`);
};

const cropHues = {
  barley: 197, // From screenshot: #027BAA
  beetroot: 270,
  broad_bean: 300,
  carrot: 330,
  common_bean: 90,
  cotton: 68, // From screenshot: #D6DF98
  grass_and_clover: 118, // From screenshot: #5DC459
  maize: 48, // From screenshot: #EEC000
  oat: 138,
  pea: 157,
  potato: 250,
  rapeseed: 36, // From screenshot: #FD9904
  rice: 183, // From screenshot: #D2E3E4
  rye: 105,
  sorghum: 236, // From screenshot: #4A53DB
  soybean: 19, // From screenshot: #EB6A2D
  sugarcane: 205, // From screenshot: #0096FF
  sunflower: 177, // From screenshot: #20D7CE
  triticale: 75,
  wheat: 10, // From screenshot: #F03A14
} satisfies {
  [key in Crop]: number;
};
export const getCropHue = (crop: Crop | undefined): number | null => {
  if (crop != null) return cropHues[crop];
  else return null;
};
